import React from "react";
import { array, string } from "prop-types";
import LeftImageRightNews from "../../../molecules/LeftImageRightNews";

import "./organism1.m.css";

const Organism1 = ({ stories, className = "" }) => (
  <div styleName="base" className={className}>
    {stories &&
      stories.map(({ story }, index) => <LeftImageRightNews story={story} key={index} widths={[160, 130, 200]} />)}
  </div>
);

Organism1.propTypes = {
  stories: array,
  className: string,
};

export default Organism1;
